import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import { getArsAgentIdApi } from "../../api/agent/getArsAgentIdApi";
import {
  connectChatServerStart,
  initChatStatus,
} from "../../../../modules/reducers/chat/agent/connectChatServer";
import { setMessage } from "#src/modules/reducers/chat/bot/qa.js";
import { initState } from "#src/modules/reducers/agreePrivacyTerm/agreePrivacy.js";
import useReactGASend from "#src/hooks/useReactGASend.js";
import { setMessage as setUnavailableMessage } from "../../../../modules/reducers/chat/agent/connectChatServer";

const useConnectChatingServer = ({
  isAgree,
  onRequestClose,
  setCheckAll,
  isClicked,
  setIsClicked,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.connectChatServer.status);
  const errorType = useSelector((state) => state.connectChatServer.errorType);
  const unavailableCount = useSelector((state) => state.connectChatServer.unavailableCount);
  const message = useSelector((state) => state.connectChatServer.message);
  const loading = useSelector((state) => state.connectChatServer.loading);
  const { makeEventTrackFn } = useReactGASend();

  const replaceEscape = (message) => {

    // message가 이미 객체인 경우
    if (typeof message === 'object') {
      dispatch(setMessage({ message }));
      return;
    }
    
    const escapedJsonString = message.replace(
      /("value"\s*:\s*")([^"]*)/g,
      (match, p1, p2) => {
        return p1 + p2.replace(/\n/g, "\\n");
      }
    );
    const parsedMsg = JSON.parse(escapedJsonString);
    dispatch(setMessage({ message: parsedMsg }));
  };

  useEffect(() => {
    if (isAgree && isClicked) {
      dispatch(initChatStatus());
      const api = getArsAgentIdApi();
      dispatch(connectChatServerStart(api));
      setIsClicked(false);
    }
  }, [isAgree, isClicked]);

  useEffect(() => {
    if (status) {
      if (status === "unavailable:service-hour" && message) {
        navigate("/chat");
        replaceEscape(message);
      } else if (status === "unavailable:online" && message) {
        navigate("/chat");
        replaceEscape(message);
      } else if (status === "unavailable:manual-operation" && message) {
        navigate("/chat");
        replaceEscape(message);
      } else if (status === "unavailable" && message) {
        makeEventTrackFn({ category: "event", action: `${errorType}-${unavailableCount}` });
  
        if (unavailableCount >= 5) {
          navigate("/service-unavailable");
        } else {
          navigate("/chat");
          replaceEscape(message);
          dispatch(setUnavailableMessage({message: null}));
        }
      } else if (status === "available") {
        navigate("/chat/agent");
      }
      setCheckAll({
        privacy: false,
        age: false,
        ProvideInform: false,
      });
      onRequestClose();
      dispatch(initState());
    }
  }, [status, message]);
  return { loading, status };
};

export default useConnectChatingServer;
